import React from 'react'
import ReactDOM from 'react-dom/client'
import SauceAlignmentGame from './App.jsx'

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <SauceAlignmentGame />
  </React.StrictMode>,
)
